import { render, staticRenderFns } from "./VideoQueueGroup.vue?vue&type=template&id=ad36908a&scoped=true&"
import script from "./VideoQueueGroup.vue?vue&type=script&lang=js&"
export * from "./VideoQueueGroup.vue?vue&type=script&lang=js&"
import style0 from "./VideoQueueGroup.vue?vue&type=style&index=0&id=ad36908a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad36908a",
  null
  
)

export default component.exports